// pagina inicio (Home): Parraffo descriptivo de Gosen.
// forma para llenar pedido cotizacion rapida

import React from 'react';
import QuickQuotationForm from '../components/QuickQuatationForm';
import QuotationList from '../components/QuotationList';
import { useUser } from '../UserContext';
import { Box, Typography } from '@mui/material';

export default function Home() {
  const { user, setUser } = useUser();

  return (
    <div>
      <div className="home-container">

        <header className="main-header">
          <img src="/gosen_logo_final.png" alt="logo" className="main-logo" />
        </header>

        <section>
          < Typography variant='h1'
            sx={{
              fontFamily: 'Helvetica, Arial, sans-serif',
              fontWeight: 600,
              fontSize: {
                xs: '90px',
                sm: '60px',
                md: '100px'
              },
              color: 'black',
              textAlign: 'center',
            }}
          > Gosén
          </Typography>

          <Typography variant='h5'
            sx={{
              fontFamily: 'Helvetica, Arial, sans-serif',
              fontWeight: 200,
              fontSize: {
                xs: '18px',
                sm: '24px',
                md: '30px'
              },
              color: '#88898a',
              textAlign: 'center',
            }}
          > Empresa Privada de Seguridad
          </Typography>

          <Box
            sx={{
              mt: 3,
              maxWidth: '90%',
              padding: 0.7,
              paddingTop: 0,
              paddingBottom: 5,
              mx: 'auto',
              textAlign: 'justify',
            }}>
            <Typography
              sx={{ fontSize: '18px' }} >
              EMPRESA PRIVADA DE SEGURIDAD GOSEN, S.A. de C.V. tiene el objetivo principal de salvaguardar sus bienes brindando seguridad privada: Empresarial, comercial, zona
              residencial, fraccionamientos, hotelera, gasolineras, escuelas, instituciones gubernamentales, en general; a personas físicas y morales, así, como a instituciones públicas y privadas que lo requieran.
              <br /><br />

              Para ello implementamos estrategias técnicas y tácticas efectivas en sistemas de seguridad y prevención, con personal debidamente capacitado con visión y objetivos bien definidos de prevenir y erradicar al máximo la incidencia de pérdidas y robos en sus diferentes modalidades en su negociación.
              <br /><br />
              Esa es nuestra misión pensando en usted, por qué; "EN SEGURIDAD, USTED ES NUESTRA PRIORIDAD" y como usted es nuestra prioridad, el proyecto de esta EMPRESA lo hemos diseñado en acorde a su necesidad.

            </Typography>
          </Box>
        </section>
        
        <section>
          <Typography variant='h4'
            sx={{
              textAlign: 'center',
              mb: 2,
              color: '#144272',
            }}
          >
            Solicite su cotización hoy mismo
          </Typography>

          <Box>
            <QuickQuotationForm />
          </Box>
        </section>
      </div>
    </div>
  );
}
